const PRIMARY_COLOR = "CLINIC_PRIMARY_COLOR" // localstorage name


const primaryColor = !window.localStorage.getItem(PRIMARY_COLOR) ? "#00B0AD" : window.localStorage.getItem(PRIMARY_COLOR)


export { PRIMARY_COLOR, primaryColor }